import React, { useState } from 'react'

function ForwardOptions(props) {
  const [message, setMessage] = useState({})

  const onForward = (param) => async (e) => {
    e.preventDefault()
    e.target.reportValidity()
    const data = new URLSearchParams()

    for (const pair of new FormData(e.target)) {
      data.append(pair[0], pair[1])
    }

    const token = document.querySelector(
      'input[name="authenticity_token"]'
    ).value

    const res = await fetch(e.target.action, {
      method: e.target.method ?? 'post',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token,
      },
      body: data,
    })

    setMessage({
      ...message,
      [param]: res.ok,
    })
  }

  return (
    <div className="forward-options">
      <a
        className="close-forward-options"
        href="#"
        aria-label="Fechar"
        onClick={(e) => {
          e.preventDefault()
          props.onClose()
        }}
      >
        ×
      </a>

      <form
        className="forward-channel"
        action={`/prescriptions/${props.id}/forward`}
        method="POST"
        onSubmit={onForward('email')}
      >
        <div className="channel">
          <i className="fal fa-envelope-open"></i>
          <span>Email</span>
        </div>

        <div className="channel-fields">
          <input
            required
            autoComplete="off"
            type="email"
            defaultValue={props.patient_email}
            name="forward[email]"
          />
          <button>
            <i className="fas fa-paper-plane"></i>
          </button>
        </div>
        {message.email && (
          <span className="forward-notice">Email enviado 🙌</span>
        )}
        {message.email === false && (
          <span className="forward-notice">
            Erro ao enviar email. Por favor verifique o endereço
          </span>
        )}
      </form>

      <form
        className="forward-channel"
        onSubmit={(e) => {
          e.preventDefault()
          e.target.reportValidity()

          let val = document
            .querySelector('input[name="whatsapp"]')
            .value.replace(/[-\s]+/g, '')
            .replace(/\(+/g, '')
            .replace(/\)+/g, '')

          if (!val.includes('+')) {
            val = `+55${val}`
          }

          const text = `Olá, aqui é a plataforma Formulapp.\nClique no link abaixo para acessar a sua prescrição digital.\n\n${props.shareable_url}`
          window.open(encodeURI(`https://wa.me/${val}?text=${text}`))
        }}
      >
        <div className="channel">
          <i className="fab fa-whatsapp"></i>
          <span>WhatsApp (número sem traços ou parenteses)</span>
        </div>
        <div className="channel-fields">
          <input
            required
            autoComplete="off"
            type="tel"
            name="whatsapp"
            defaultValue={props.patient_phone}
          />
          <button>
            <i className="fas fa-paper-plane"></i>
          </button>
        </div>
      </form>
    </div>
  )
}

export default function ForwardPrescription(props) {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault()
          setExpanded(true)
        }}
      >
        <i
          className="fas fa-share-all"
          style={{
            color: 'green',
          }}
        ></i>
        <span>Encaminhar</span>
      </a>

      {expanded && (
        <ForwardOptions {...props} onClose={() => setExpanded(false)} />
      )}
    </>
  )
}
